// extracted by mini-css-extract-plugin
export default {"switchGroup":"switchGroup__S7GFa","switchLabel":"switchLabel__ruFY5","switchIndicator":"switchIndicator__UdDwW"};